import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';

function AccountView() {
  const { currentUser, logout } = useAuth();

  return (
    <div className="account-container">
      <img 
        src={currentUser?.photoURL || `https://ui-avatars.com/api/?name=${currentUser?.displayName || 'User'}&background=random`} 
        alt="Profile" 
        className="account-avatar" 
      />
      <h2 className="account-name">{currentUser?.displayName || 'Unknown User'}</h2>
      <p className="account-email">{currentUser?.email || 'No email provided'}</p>
      
      <button className="logout-btn" onClick={logout}>
        Log Out
      </button>
    </div>
  );
}

export default AccountView;
